import Accounts from './accounts'
import Affiliations from './affiliations'
import Communication from './communication'
import Me from './me'
import Users from './users'
import Silos from './silos'
import Images from './images'
import Tags from './tags'
import Templates from './templates'
import Messages from './messages'
import ContentBlocks from './content-blocks'
import Offers from './offers'
import Audiences from './audiences'
import TestMessage from './test-message'
import TestSend from './test-send'
import SummaryReports from './summary-reports'
import TypedValues from './typed-value'

const resources = {}

export default class OspreyApi {

    _getApiObjectInstance(name, ctor) {
        if (!resources[name]) {
            resources[name] = new ctor()
        }

        return resources[name]
    }

    get accounts() {
        return this._getApiObjectInstance('accounts', Accounts)
    }

    get communication() {
        return this._getApiObjectInstance('communication', Communication)
    }

    get me() {
        return this._getApiObjectInstance('me', Me)
    }

    get users() {
        return this._getApiObjectInstance('users', Users)
    }

    get silos() {
        return this._getApiObjectInstance('silos', Silos)
    }

    get images() {
        return this._getApiObjectInstance('images', Images)
    }

    get tags() {
        return this._getApiObjectInstance('tags', Tags)
    }

    get affiliations() {
        return this._getApiObjectInstance('affiliations', Affiliations)
    }

    get templates() {
        return this._getApiObjectInstance('templates', Templates)
    }

    get messages() {
        return this._getApiObjectInstance('messages', Messages)
    }

    get 'content-blocks'() {
        return this._getApiObjectInstance('content-blocks', ContentBlocks)
    }

    get offers() {
        return this._getApiObjectInstance('offers', Offers)
    }

    get audiences() {
        return this._getApiObjectInstance('audiences', Audiences)
    }

    get testMessage() {
        return this._getApiObjectInstance('testMessage', TestMessage)
    }

    get 'test-emails'() {
        return this._getApiObjectInstance('test-emails', TestSend)
    }

    get 'summary-reports'() {
        return this._getApiObjectInstance('summary-reports', SummaryReports)
    }

    get 'typed-values'() {
        return this._getApiObjectInstance('typed-values', TypedValues)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/index.js